import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { MessageService, ConfirmationService } from 'primeng/api';


const importExportArray = [
  ToastModule,
  PasswordModule,
  OverlayPanelModule,
  TooltipModule,
  ConfirmDialogModule,
  DialogModule,
  MultiSelectModule,
  DropdownModule,
  SelectButtonModule,
  DynamicDialogModule,
  MessagesModule,
  TableModule,
];

@NgModule({
  declarations: [],
  imports: importExportArray,
  exports: importExportArray
})
export class PrimengImportsModule { }
